// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"482":"10b990df","643":"8d6cc02b"}[chunkId] || chunkId) + "." + {"204":"5e11de448e841ff1","373":"46c6461411f17f6c","482":"add885e3857f4e1e","643":"f71dee0802678da1","914":"0fc742ddbae542fe"}[chunkId] + ".js";
};